import { Button } from "@omni/ui/components/Button/button.component";
import { PropsWithChildren } from "react";

import { useCallToActionContext } from "@/components/General/CallToAction/callToAction.context";

type PrintButtonProps = PropsWithChildren<{}>;

const PrintButton = ({ children }: PrintButtonProps) => {
    const { trackingProperties } = useCallToActionContext();

    return (
        <Button
            type="button"
            color="link"
            dataAttributes={{
                ...trackingProperties.click
            }}
            onClick={() => window.print()}
        >
            {children}
        </Button>
    );
};

export { PrintButton };
